module.exports = __webpack_public_path__ + "static/img/A94.5c45e5f6.jpg";